// src/components/NewsSectionTwo.jsx
import React from "react";

const defaultItems = [
  {
    title: "Our Mission",
    text:
      "Our mission is rooted in providing an exceptional living experience. We strive to offer not just accommodation but a lifestyle that enhances the overall quality of our residents lives. Through continuous innovation, personalized services, and a commitment to community building, we aim to make Shree Swami Samarth PG a place you are proud to call home.",
  },
  {
    title: "Our Vision",
    text:
      "Our vision at Shree Swami Samarth PG is to redefine the concept of shared living. We envision a community where residents feel a deep sense of comfort, security, and camaraderie. By creating an environment that prioritizes both individual needs and collective wellbeing, we aim to be the preferred choice for those seeking a harmonious living space.",
  },
  {
    title: "Goals",
    text:
      "the goals for Shree Swami Samarth PG are to provide residents with an exceptional and safe living experience, foster a sense of community through engaging activities, offer flexible accommodation options, maintain transparent communication, and continuously improve services. The PG aims to contribute to residents' overall well-being, support their educational.",
  },
];

export default function NewsSectionTwo({ items = defaultItems }) {
  return (
    <section className="news-section-two">
      <div className="auto-container">
        <div className="row clearfix">
          {items.map((it, i) => (
            <div className="news-block-two col-md-4 col-sm-6 col-xs-12" key={i}>
              <div className="inner-box">
                <div className="lower-box">
                  <h3>{it.title}</h3>
                  <div className="text">
                    <p>{it.text}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
